import { render, staticRenderFns } from "./userinfoIndex.vue?vue&type=template&id=163fc6bc&scoped=true&"
import script from "./userinfoIndex.vue?vue&type=script&lang=js&"
export * from "./userinfoIndex.vue?vue&type=script&lang=js&"
import style0 from "./userinfoIndex.vue?vue&type=style&index=0&id=163fc6bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fc6bc",
  null
  
)

export default component.exports